import React, { useState } from "react";
import { Typography, Box, FormControlLabel } from "@mui/material";
import { ToggleSwitch } from "../../../Common_Components/ToggleSwitch";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";

const CaptionSettingsForHeygen = (props) => {
  const theme = localStorage.getItem("theme");

  const { captionForHeygenVideo, setCaptionForHeygenVideo } = useWorkspace();
  
  // Only update from props if setState function is provided
  React.useEffect(() => {
    if (props.setState && props.state !== undefined) {
      setCaptionForHeygenVideo(props.state);
    }
  }, [props.state]);

  return (
    <Box sx={{ padding: "20px 0px 0px 0px" }}>
      <Box sx={{ display: "flex", flexDirection: "row", columnGap: "12px" }}>
        <Typography sx={{ color: "white" }}>Captions</Typography>
      </Box>
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            mt: 3,
            backgroundColor: "#2F355F",
            padding: 1.5,
            borderRadius: 1,
          }}
        >
          <Typography
            id=""
            variant="h6"
            component="h2"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              font: "Inter",
            }}
            style={{
              fontFamily: "Inter",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              color: theme === "dark" ? "#FFFFFF" : "",
            }}
          >
            Enable captions
          </Typography>

          <FormControlLabel
            onClick={(e) => {
              const newValue = !captionForHeygenVideo;
              setCaptionForHeygenVideo(newValue);
              // Only call props.setState if it's provided (from VideoGenerate.jsx)
              if (props.setState && typeof props.setState === 'function') {
                props.setState(newValue);
              }
            }}
            control={
              <ToggleSwitch
                sx={{ transform: "scale(0.8)" }}
                // defaultChecked={callingAgentUserProfileData?.enable_follow_up_notification}
                checked={captionForHeygenVideo}
              />
            }
            // label=""
            // labelPlacement=""
            sx={{
              whiteSpace: "nowrap",
              margin: 0, // Removes default margin
              maxWidth: "100%", // Ensures it doesn't exceed the parent's width
              display: "flex",
              alignItems: "center",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CaptionSettingsForHeygen;
